import * as React from "react";
import styled from "@emotion/styled";
import { Row, Col } from "reactstrap";
import {
  TiClipboard,
  TiCalendar,
  TiGroup,
  TiChartBarOutline,
  TiSpannerOutline,
  TiStarOutline
} from "react-icons/ti";

// Theme
import { Images, Colors } from "../../Themes";

const Container = styled.div`
  background: #f3f5f9;
  height: auto;
  padding-top: 30px;
  padding-bottom: 80px;
`;

const SubHeadingContainer = styled.div`
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
  & img {
    width: 550px;
  }
  @media (max-width: 800px) {
    & img {
      width: 100%;
    }
  }
`;

const H2 = styled.h2`
  font-weight: 700;
  font-size: 2.17em;
  text-align: center;
`;

const H3 = styled.h3`
  font-weight: 700;
  font-size: 1.37em;
  text-align: center;
  text-transform: capitalize;
`;

const P = styled.p`
  font-size: 1.15em;
`;

const CardContainer = styled.div`
  width: calc(100% - 200px);
  margin: 0 auto;
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const Card = styled.div`
  width: calc(100% - 20px);
  padding: 20px;
  margin: 0 auto;
  text-align: center;
  background: #fff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  height: 220px;
  border-bottom: 4px solid ${Colors.cmmsBlue};
  @media (max-width: 800px) {
    margin-bottom: 50px;
  }
`;

const CardIcon = styled.div`
  width: 55px;
  height: 55px;
  text-align: center;
  border-radius: 50%;
  margin: 0 auto;
  background: ${Colors.cmmsBlue};
  box-shadow: 0 0 0 8px rgba(84, 149, 248, 0.42);
  position: relative;
  top: -35px;
`;

class Features extends React.Component<{}> {
  render() {
    return (
      <Container>
        <SubHeadingContainer>
          <H2>
            Spreadsheets and paperwork aside, <br />
            Maintain is here.
          </H2>
          <br />
          <P>
            Perform maintenance tasks better and faster
            <br /> with Maintain CMMS.
          </P>
          <img alt="Home Page Mockup" src={Images.mockupOne} />
        </SubHeadingContainer>
        <CardContainer>
          <Row>
            <Col xs={12} md={4} lg={4}>
              <Card>
                <CardIcon>
                  <TiClipboard
                    size="2.05em"
                    color={Colors.snow}
                    style={{ position: "relative", top: "15px" }}
                  />
                </CardIcon>
                <H3>Work orders</H3>
                <P>
                  Create maintenance work orders, and assign the right techincal
                  person or team with the information they need to get the job
                  done.{" "}
                </P>
              </Card>
            </Col>
            <Col xs={12} md={4} lg={4}>
              <Card>
                <CardIcon>
                  <TiGroup
                    size="2.05em"
                    color={Colors.snow}
                    style={{ position: "relative", top: "15px" }}
                  />
                </CardIcon>
                <H3>Manage Technicians</H3>
                <P>
                  Add your techincal team to the platform, assign them to work
                  orders or as primary users of certain company assets.{" "}
                </P>
              </Card>
            </Col>
            <Col xs={12} md={4} lg={4}>
              <Card>
                <CardIcon>
                  <TiCalendar
                    size="2.05em"
                    color={Colors.snow}
                    style={{ position: "relative", top: "15px" }}
                  />
                </CardIcon>
                <H3>Scheduled Maintenance</H3>
                <P>
                  Not all work orders are created equal, Maintain helps you
                  create recurring/ongoing maintenance that needs to be carried
                  out for particular work orders.{" "}
                </P>
              </Card>
            </Col>
          </Row>
          <br />
          <br />
          <br />
          <br />
          <Row>
            <Col xs={12} md={4} lg={4}>
              <Card>
                <CardIcon>
                  <TiChartBarOutline
                    size="2.05em"
                    color={Colors.snow}
                    style={{ position: "relative", top: "15px" }}
                  />
                </CardIcon>
                <H3>Reports &amp; Analytics</H3>
                <P>
                  Have a graphical representation of your team's efficiency
                  based on work order completion and customer request responses.{" "}
                </P>
              </Card>
            </Col>
            <Col xs={12} md={4} lg={4}>
              <Card>
                <CardIcon>
                  <TiStarOutline
                    size="2.05em"
                    color={Colors.snow}
                    style={{ position: "relative", top: "15px" }}
                  />
                </CardIcon>
                <H3>Asset Management</H3>
                <P>
                  No need for old and unreliable ways of tracking assets. Store
                  the right information, including locations and the primary
                  users of each one.{" "}
                </P>
              </Card>
            </Col>
            <Col xs={12} md={4} lg={4}>
              <Card>
                <CardIcon>
                  <TiSpannerOutline
                    size="2.05em"
                    color={Colors.snow}
                    style={{ position: "relative", top: "15px" }}
                  />
                </CardIcon>
                <H3>Inventory Management</H3>
                <P>
                  Keep stock of all your company parts and supplies, with the
                  details of each one for better automated management of your
                  inventory.{" "}
                </P>
              </Card>
            </Col>
          </Row>
        </CardContainer>
      </Container>
    );
  }
}

export default Features;



// WEBPACK FOOTER //
// ./src/Containers/Home/Features.tsx